import { apiGet, apiDelete, apiPost, apiPut } from './api_call/api_methods'
import { getHeaders } from './common';

export const fetchEvent = async (eventId) => {
    return apiGet({ endpoint: `${process.env.REACT_APP_EVENT_API_URL}/${eventId}`, error_message: "Failed to fetch event" });
};

export const fetchOrganizationEvents = async (orgId) => {
    if (!orgId) return { success: false, error: "Organization ID is required" };
    return apiGet({ endpoint: `${process.env.REACT_APP_EVENT_API_URL}/org/${orgId}`, error_message: "Failed to fetch event" });
};

export const createEvent = async (eventData) => {
    if (!eventData) return { success: false, error: "Event data is required" };
    return apiPost({ endpoint: `${process.env.REACT_APP_EVENT_API_URL}`, body: eventData, successMessage: "Event added!", errorMessage: "Failed to create event" })
};

export const updateEvent = async (eventData) => {
    if (!eventData || !eventData.id)
        return { success: false, error: "Event data with ID is required" };
    return apiPut({ endpoint: `${process.env.REACT_APP_EVENT_API_URL}`, body: eventData, successMessage: "Event updated!", errorMessage: "Failed to update event" })
};

export const deleteEvent = async (eventId) => {
    if (!eventId) return { success: false, error: "Event ID is required" };
    return apiDelete({ endpoint: `${process.env.REACT_APP_EVENT_API_URL}/${eventId}`, successMessage: "Event deleted successfully!", error_message: "Failed to delete event" });
};

export const linkDevicesToEvent = async (eventId, deviceIds) => {
    if (!eventId || !deviceIds) return { success: false, error: "Event ID and device IDs are required" };
    var obj = { eventId: eventId, deviceId: deviceIds }
    return apiPost({ endpoint: `${process.env.REACT_APP_EVENT_API_URL}/LinkDevicesToEvent`, body: obj, successMessage: "Devices linked to event successfully!", errorMessage: "Failed to link devices to event" })
};

export const generateShareableLink = async (eventId) => {
    try {
        if (!eventId) return { success: false, error: "Event ID is required" };

        const response = await fetch(
            `${process.env.REACT_APP_DEVICE_API_URL}/VideoCallInvite`,
            {
                method: "POST",
                headers: {
                    ...getHeaders(),
                    'accept': 'text/plain'
                },
                body: JSON.stringify({
                    EventId: eventId,
                }),
                credentials: "include",
            }
        );

        if (response.ok) {
            const data = await response.json();
            return { success: true, data };
        } else {
            const errorData = await response.text();
            console.error("API Error:", errorData);
            return { success: false, error: "Failed to generate shareable link" };
        }
    } catch (error) {
        console.error("Error generating shareable link:", error);
        return { success: false, error: error.message };
    }
};

export const sendEventEmailInvite = async (eventId) => {
    if (!eventId) return { success: false, error: "Event ID is required" };
    return apiPost({ endpoint: `${process.env.REACT_APP_EVENT_API_URL}/SendEventEmailInvite/${eventId}`, successMessage: "Email invitations sent successfully", errorMessage: "Failed to send email invitations" })
};